import { init } from "./lib";

window.addEventListener("load", () => {
  const $ = window.$ || window.jQuery || window.jquery;
  if (!$) {
    throw new Error("jquery is required");
  }
  return init($).run();
});
